import jwt_decode from "jwt-decode";

export function decodeToken(token) {
  if (!token || typeof token !== "string") {
    return null;
  }
  try {
    return jwt_decode(token);
  } catch {
    return null;
  }
}

export function getStoredUser() {
  return decodeToken(localStorage.getItem("token"));
}

export function getStoredUserId() {
  return getStoredUser()?.user?._id || "";
}

export function clearInvalidAuthToken() {
  const token = localStorage.getItem("token");
  if (token && !decodeToken(token)) {
    localStorage.removeItem("token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("userId");
    return true;
  }
  return false;
}
